// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__j7bv3","location":"Header_location__3p0tt"};